import { useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

function BookingModal({ exp, config, onClose }) {
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({ name: '', email: '', phone: '', guests: 1, notes: '' });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const pc = config.primaryColor;

  const submit = async () => {
    if (!form.name || !form.email) return;
    setSubmitting(true);
    try {
      await fetch(`${API_URL}/api/experiences/${exp.id}/bookings`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, experience_id: exp.id }),
      });
      setSubmitted(true);
    } catch { setSubmitted(true); }
    finally { setSubmitting(false); }
  };

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.6)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }} onClick={onClose}>
      <div style={{ background:'#fff', borderRadius:20, width:'100%', maxWidth:420, overflow:'hidden', maxHeight:'90vh', overflowY:'auto' }} onClick={e=>e.stopPropagation()}>
        <div style={{ background:`linear-gradient(135deg,${pc},${pc}cc)`, padding:'24px 24px 20px', textAlign:'center' }}>
          <p style={{ fontSize:22, marginBottom:8 }}>✨</p>
          <h2 style={{ color:'#fff', fontWeight:700, fontSize:18, margin:0 }}>{exp.name}</h2>
          {exp.price!=null && <p style={{ color:'rgba(255,255,255,0.8)', margin:'6px 0 0', fontWeight:600 }}>{exp.price===0?'Gratis':`$${exp.price}`}</p>}
        </div>
        {submitted ? (
          <div style={{ padding:32, textAlign:'center' }}>
            <div style={{ fontSize:48, marginBottom:12 }}>✅</div>
            <h3 style={{ fontWeight:700, color:'#111827', marginBottom:8 }}>¡Solicitud enviada!</h3>
            <p style={{ color:'#6b7280', marginBottom:20, fontSize:14 }}>Nos pondremos en contacto para confirmar tu reserva.</p>
            <button onClick={onClose} style={{ padding:'10px 24px', background:pc, color:'#fff', border:'none', borderRadius:10, fontWeight:600, cursor:'pointer' }}>Cerrar</button>
          </div>
        ) : (
          <div style={{ padding:24 }}>
            <div style={{ display:'flex', flexDirection:'column', gap:12, marginBottom:20 }}>
              {[
                { key:'name', label:'Nombre completo *', type:'text', ph:'Tu nombre' },
                { key:'email', label:'Correo electrónico *', type:'email', ph:'tu@email.com' },
                { key:'phone', label:'WhatsApp / Teléfono', type:'tel', ph:'+52 55 0000 0000' },
              ].map(f => (
                <div key={f.key}>
                  <label style={{ fontSize:12, fontWeight:600, color:'#6b7280', display:'block', marginBottom:4 }}>{f.label}</label>
                  <input type={f.type} placeholder={f.ph} value={form[f.key]} onChange={e=>setForm(p=>({...p,[f.key]:e.target.value}))}
                    style={{ width:'100%', padding:'10px 12px', border:'1px solid #e5e7eb', borderRadius:10, fontSize:13, outline:'none', boxSizing:'border-box' }} />
                </div>
              ))}
              <div>
                <label style={{ fontSize:12, fontWeight:600, color:'#6b7280', display:'block', marginBottom:4 }}>Número de personas</label>
                <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                  <button onClick={()=>setForm(p=>({...p,guests:Math.max(1,p.guests-1)}))} style={{ width:36,height:36,borderRadius:'50%',border:'2px solid #e5e7eb',background:'transparent',cursor:'pointer',fontSize:20,fontWeight:700 }}>−</button>
                  <span style={{ fontSize:24, fontWeight:800, color:pc, width:32, textAlign:'center' }}>{form.guests}</span>
                  <button onClick={()=>setForm(p=>({...p,guests:Math.min(20,p.guests+1)}))} style={{ width:36,height:36,borderRadius:'50%',border:'2px solid #e5e7eb',background:'transparent',cursor:'pointer',fontSize:20,fontWeight:700 }}>+</button>
                </div>
              </div>
              <div>
                <label style={{ fontSize:12, fontWeight:600, color:'#6b7280', display:'block', marginBottom:4 }}>Notas adicionales</label>
                <textarea value={form.notes} onChange={e=>setForm(p=>({...p,notes:e.target.value}))} placeholder="Peticiones especiales..."
                  style={{ width:'100%', padding:'10px 12px', border:'1px solid #e5e7eb', borderRadius:10, fontSize:13, outline:'none', resize:'none', minHeight:60, boxSizing:'border-box' }} />
              </div>
            </div>
            <div style={{ display:'flex', gap:10 }}>
              <button onClick={onClose} style={{ flex:1, padding:'12px', border:'1px solid #e5e7eb', borderRadius:10, background:'transparent', cursor:'pointer', fontWeight:600 }}>Cancelar</button>
              <button disabled={!form.name||!form.email||submitting} onClick={submit}
                style={{ flex:2, padding:'12px', border:'none', borderRadius:10, background:(!form.name||!form.email)?'#e5e7eb':pc, color:'#fff', fontWeight:700, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:8 }}>
                {submitting ? '...' : config.buttonText || 'Reservar ahora'}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default function ExperiencesWidgetPublicPage() {
  const { restaurantId } = useParams();
  const [searchParams] = useSearchParams();
  const [experiences, setExperiences] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedExp, setSelectedExp] = useState(null);
  const [catFilter, setCatFilter] = useState('all');
  const [search, setSearch] = useState('');

  const config = {
    primaryColor: `#${searchParams.get('color') || 'F97316'}`,
    backgroundColor: `#${searchParams.get('bg') || 'FFFFFF'}`,
    textColor: `#${searchParams.get('text') || '1E293B'}`,
    layout: searchParams.get('layout') || 'grid',
    fontFamily: searchParams.get('font') || 'inter',
    borderRadius: parseInt(searchParams.get('radius') || '12', 10),
    showPrice: searchParams.get('showPrice') !== 'false',
    showDuration: searchParams.get('showDuration') !== 'false',
    showCategory: searchParams.get('showCategory') !== 'false',
    showDescription: searchParams.get('showDescription') !== 'false',
    showBookingButton: searchParams.get('showBookingButton') !== 'false',
    maxExperiences: parseInt(searchParams.get('maxExperiences') || '6', 10),
    buttonText: searchParams.get('btnText') ? decodeURIComponent(searchParams.get('btnText')) : 'Reservar ahora',
    buttonStyle: searchParams.get('btnStyle') || 'filled',
    theme: searchParams.get('theme') || 'light',
    filterByCategory: searchParams.get('cat') || 'all',
  };

  const isDark = config.theme === 'dark';
  const pc = config.primaryColor;
  const br = `${config.borderRadius}px`;
  const ff = { inter:"'Inter',sans-serif", poppins:"'Poppins',sans-serif", playfair:"'Playfair Display',serif" }[config.fontFamily] || "'Inter',sans-serif";

  useEffect(() => {
    fetch(`${API_URL}/api/experiences/public/${restaurantId}`)
      .then(r => r.ok ? r.json() : [])
      .then(data => { setExperiences(Array.isArray(data) ? data : []); setLoading(false); })
      .catch(() => setLoading(false));
  }, [restaurantId]);

  const cats = [...new Set(experiences.map(e => e.category).filter(Boolean))];
  const filtered = experiences.filter(e => {
    const matchCat = catFilter === 'all' || e.category === catFilter;
    const matchSearch = !search || e.name.toLowerCase().includes(search.toLowerCase());
    return matchCat && matchSearch;
  }).slice(0, config.maxExperiences);

  const btnStyle = {
    backgroundColor: config.buttonStyle === 'filled' ? pc : 'transparent',
    color: config.buttonStyle === 'filled' ? '#fff' : pc,
    border: config.buttonStyle === 'ghost' ? 'none' : `2px solid ${pc}`,
    borderRadius: `calc(${br} - 2px)`,
    padding: '10px 20px', fontSize: '13px', fontWeight: 700, cursor: 'pointer', width: '100%', marginTop: 10, fontFamily: ff,
  };

  return (
    <div style={{ minHeight:'100vh', background: isDark ? '#0f172a' : '#f8fafc', fontFamily: ff }}>
      <div style={{ maxWidth:900, margin:'0 auto', padding:'32px 16px' }}>
        <div style={{ backgroundColor: config.backgroundColor, borderRadius: br, padding: 28, boxSizing: 'border-box' }}>
          {/* Search + filters */}
          <div style={{ marginBottom:20 }}>
            <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="🔍  Buscar experiencias..."
              style={{ width:'100%', padding:'10px 14px', borderRadius:br, border:`1.5px solid ${isDark?'#475569':'#e2e8f0'}`, backgroundColor: isDark?'#1e293b':'#f8fafc', color:config.textColor, fontFamily:ff, fontSize:13, outline:'none', boxSizing:'border-box', marginBottom:10 }} />
            {cats.length > 0 && (
              <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
                {['all',...cats].map(c=>(
                  <button key={c} onClick={()=>setCatFilter(c)} style={{ padding:'4px 14px', borderRadius:20, border:`1.5px solid ${catFilter===c?pc:'#e5e7eb'}`, background:catFilter===c?pc:'transparent', color:catFilter===c?'#fff':config.textColor, fontSize:12, fontWeight:600, cursor:'pointer' }}>{c==='all'?'Todas':c}</button>
                ))}
              </div>
            )}
          </div>

          {loading ? (
            <div style={{ textAlign:'center', padding:'60px 0', color:'#9ca3af' }}><div style={{ fontSize:32, marginBottom:8 }}>✨</div><p>Cargando experiencias...</p></div>
          ) : filtered.length === 0 ? (
            <div style={{ textAlign:'center', padding:'60px 0', opacity:0.4 }}><div style={{ fontSize:48, marginBottom:12 }}>✨</div><p style={{ fontSize:14 }}>No hay experiencias disponibles</p></div>
          ) : (
            <div style={{ display:'grid', gridTemplateColumns: config.layout==='list'?'1fr':'repeat(auto-fill,minmax(210px,1fr))', gap:16 }}>
              {filtered.map(exp => (
                <div key={exp.id} style={{ backgroundColor: isDark?'#1e293b':'#fff', borderRadius:br, overflow:'hidden', border:`1px solid ${isDark?'#334155':'#e2e8f0'}`, boxShadow:'0 1px 4px rgba(0,0,0,0.06)', display:'flex', flexDirection: config.layout==='list'?'row':'column' }}>
                  <div style={{ background:`linear-gradient(135deg,${pc}20,${pc}50)`, height: config.layout==='list'?'auto':'120px', width: config.layout==='list'?'100px':'100%', minHeight: config.layout==='list'?'80px':'auto', flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center', fontSize:30 }}>✨</div>
                  <div style={{ padding:14, flex:1, display:'flex', flexDirection:'column' }}>
                    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:8, marginBottom:6 }}>
                      <h3 style={{ margin:0, fontSize:14, fontWeight:700, color:config.textColor, lineHeight:1.3 }}>{exp.name}</h3>
                      {config.showPrice && exp.price!=null && <span style={{ fontSize:15, fontWeight:800, color:pc, flexShrink:0 }}>{exp.price===0?'Gratis':`$${exp.price}`}</span>}
                    </div>
                    <div style={{ display:'flex', flexWrap:'wrap', gap:5, marginBottom:8 }}>
                      {config.showCategory && exp.category && <span style={{ fontSize:11, padding:'2px 10px', borderRadius:100, backgroundColor:`${pc}15`, color:pc, fontWeight:600 }}>{exp.category}</span>}
                      {config.showDuration && exp.duration && <span style={{ fontSize:11, padding:'2px 10px', borderRadius:100, backgroundColor: isDark?'#334155':'#f1f5f9', color:'#64748b', fontWeight:600 }}>⏱ {exp.duration} min</span>}
                    </div>
                    {config.showDescription && exp.description && <p style={{ margin:'0 0 8px', fontSize:12, opacity:0.65, lineHeight:1.5, flex:1 }}>{exp.description.length>80?exp.description.slice(0,80)+'…':exp.description}</p>}
                    {config.showBookingButton && <button style={btnStyle} onClick={()=>setSelectedExp(exp)}>{config.buttonText}</button>}
                  </div>
                </div>
              ))}
            </div>
          )}

          <p style={{ textAlign:'center', fontSize:11, color:'#9ca3af', marginTop:24, marginBottom:0 }}>Powered by <strong style={{ color:'#f97316' }}>OkReserva</strong></p>
        </div>
      </div>

      {selectedExp && <BookingModal exp={selectedExp} config={config} onClose={()=>setSelectedExp(null)} />}
    </div>
  );
}
